// extracted by mini-css-extract-plugin
module.exports = {"card":"payment-request-form_card__1JXu6","submitButton":"payment-request-form_submitButton__1T6GR","paymentRequestButton":"payment-request-form_paymentRequestButton__3L0dk"};